'use client';

import { Trans, t } from '@lingui/macro';
import { Close, Message } from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Popover,
  Popper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useHubspot } from '../../../hooks/use-hubspot';

export const Chat = () => {
  const { chatIsVisible, openChat, closeChat, unreadCount } = useHubspot();

  const btnEl = useRef<any>(undefined);
  const [forceCloseSupport, setForceCloseSupport] = useState<boolean>(false);
  const [anchorElSupport, setAnchorElSupport] = useState<
    HTMLElement | undefined
  >(undefined);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  useEffect(() => {
    if (chatIsVisible && !!btnEl.current) {
      setAnchorEl(btnEl.current);
      setForceCloseSupport(true);
    } else {
      setAnchorEl(undefined);
    }
  }, [chatIsVisible, btnEl.current]);

  useEffect(() => {
    if (!!btnEl.current && !anchorElSupport && !forceCloseSupport) {
      setAnchorElSupport(btnEl.current);
    }
  }, [anchorElSupport, btnEl, forceCloseSupport]);

  const open = Boolean(anchorEl);
  const openSupport = !forceCloseSupport && Boolean(anchorElSupport);

  return (
    <>
      <Tooltip title={t`Chat d'aide à l'utilisation`} placement="top">
        <IconButton ref={btnEl} color="primary" onClick={openChat}>
          <Badge badgeContent={unreadCount} color="error">
            <Message />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={closeChat}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
      >
        <Box
          component="div"
          height="530px"
          width="400px"
          maxHeight="100vh"
          maxWidth="100vw"
          position="relative"
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              position: 'absolute',
              zIndex: 0,
            }}
          >
            <CircularProgress />
          </Stack>
          <Box
            component="div"
            id="hs-chat-element-custom"
            position="relative"
            width="100%"
            height="100%"
            zIndex={10}
          />
        </Box>
      </Popover>
      <Popper
        open={openSupport}
        anchorEl={anchorElSupport}
        placement="top"
        sx={{ zIndex: 10000000000000 }}
      >
        <Paper elevation={4}>
          <Box
            component="div"
            padding={2}
            paddingTop={4}
            margin={1}
            borderRadius={2}
            bgcolor="white"
            width="250px"
            position="relative"
          >
            <Avatar
              sx={{
                top: 0,
                left: '50%',
                transform: 'translate(-50%, -50%)',
                position: 'absolute',
              }}
              src="/assets/marketing/florian-m-avatar.webp"
            />
            <IconButton
              onClick={() => setForceCloseSupport(true)}
              sx={{ top: 0, right: 0, position: 'absolute' }}
              size="small"
            >
              <Close color="gray" fontSize="small" />
            </IconButton>
            <Typography textAlign="center">
              <Trans>
                Bonjour, je suis Florian de PRISMO 👋. Si vous rencontrez des
                problèmes dans l'utilisation de PRISMO App, je peux vous aider.
              </Trans>
            </Typography>
          </Box>
        </Paper>
      </Popper>
    </>
  );
};
